export const WORK_MANAGER_ALLOWED_ROLES: string[] = [
    'copilot',
    'Topcoder Customer',
    'administrator',
    'Project Manager',
    'Client Manager',
    'Talent Manager',
]
